import { EntityActionFactory, EntityOp } from '@ngrx/data';

import { TipoDivisorMuestra } from './tipos-divisor-muestra.model';

const entityActionFactory = new EntityActionFactory();

export const entityTiposDivisorMuestraLoadRequest =
  entityActionFactory.create<TipoDivisorMuestra>(
    'TipoDivisorMuestra',
    EntityOp.QUERY_ALL
  );
